export const BaseAPIUrl = process.env.REACT_APP_SERVER_URL + "/admin-1228";

export const httpFetch = (url, config) => {
  return fetch(BaseAPIUrl + url, config)
    .then((res) => res.json())
    .catch((err) => err);
};
